export const writeStorage = (key, value, storageType = 'local') => {
  if (storageType === 'local') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
};

export const readStorage = (key, storageType = 'local') => {
  if (storageType === 'local') {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return JSON.parse(sessionStorage.getItem(key));
  }
};

export const removeStorage = (key, storageType = 'local') => {
  if (storageType === 'local') {
    localStorage.removeItem(key);
  } else {
    sessionStorage.removeItem(key);
  }
};
